var twig = require("twig").twig,
    template = twig({"id":"e4929375614d55884d60ca5aa61763b5d4d93136f69dfd7a4f97c21847035f697f99a9434e53979c874022d05e2a345bf39360c706b56ff566da378b06199e7c","data":[{"type":"raw","value":"<div class=\"yandex-map__dot-marker\"></div>\n"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }